import {call, put, takeLatest} from 'redux-saga/effects';
import {base_url, endpoints} from '../../../constants';
import {AxiosService} from '../../../services';
import {actionTypes} from '../../../types';
import {
    verifyMobileOtpFailure,
    verifyMobileOtpSuccess
} from "../../actions/authActions/verifyMobileOtpActions";

function* verifyMobileOtp({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.verifyMobileOtp,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("VERIFY_MOBILE_OTP_SUCCESS status :", response.data.status);
        console.log("VERIFY_MOBILE_OTP_SUCCESS data :", response.data.response);
        console.log("VERIFY_MOBILE_OTP_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            verifyMobileOtpSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("VERIFY_MOBILE_OTP_FAILURE status :", error?.response?.status);
        console.log("VERIFY_MOBILE_OTP_FAILURE data:", error?.response?.data);
        console.log("VERIFY_MOBILE_OTP_FAILURE error :", error);
        console.log('====================================');
        yield put(verifyMobileOtpFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* verifyMobileOtpSaga() {
    yield takeLatest(actionTypes.VERIFY_MOBILE_OTP_REQUEST, verifyMobileOtp);
}

export default verifyMobileOtpSaga;
